import { IonButton } from '@ionic/react'
import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props: any) {
    super(props)
    this.state = { error: null, errorInfo: null }
  }

  componentDidCatch(error: any, errorInfo: any) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    })
    // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <div>
          <h2>{'خطایی رخ داد'}</h2>
          <IonButton className='ion-padding' onClick={() => window.location.reload()}>
            {'بروز رسانی صفحه'}
          </IonButton>
          <IonButton className='ion-padding' onClick={() => (window.location.href = '/')}>
            {'برگشت به صفحه اصلی'}
          </IonButton>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      )
    }
    // Normally, just render children
    return this.props.children
  }
}

export default ErrorBoundary
